import { useEffect, useState } from "react";
import * as Yup from "yup";
import { FormikProvider, Form, Field, ErrorMessage, useFormik } from "formik";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { config } from "../CommonUtils/CommonURLS";
import { commonColumn, serialNumberColumn } from "../CommonUtils/CommunColumns";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin2Line } from "react-icons/ri";
import { BiTrash } from "react-icons/bi";

function AddDepartment() {
  const [deptTableData, setDeptTableData] = useState([]);
  const [serviceId, setServiceId] = useState(null); // ✅ For Edit Mode

  // ✅ Validation
  const validationSchema = Yup.object({
    deptName: Yup.string().required(ERROR_MSG).nullable(),
  });

  // ✅ Formik
  const serviceFormik = useFormik({
    initialValues: {
      deptName: "",
    },
    validationSchema,
    onSubmit: (val) => {
      const payload = {
        deptName: val.deptName,
      };
      Swal.fire({
        text: "Are you sure you want to submit?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes Submit!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let url = "";
          // ✅ If Editing → Update API
          if (serviceId !== null) {
            url = config.url.FAC_URL + "updateDept?deptId=" + serviceId;
          }
          // ✅ Else → Save API
          else {
            url = config.url.FAC_URL + "saveDepartment";
          }
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                successAlert2(res?.data?.sdesc);
                serviceFormik.resetForm();
                setServiceId(null); // Reset edit mode
                GetServiceTableDetails();
              } else {
                failureAlert(res?.data?.sdesc);
              }
            })
            .catch((error) => {
              console.error("API Error:", error);
              failureAlert("An error occurred while submitting the data.");
            });
        }
      });
    },
  });

  // ✅ Get Departments
  function GetServiceTableDetails() {
    let url = config.url.FAC_URL + "getDept";
    CommonAxiosGet(url).then((response) => {
      if (response?.data?.status === true) {
        setDeptTableData(response?.data?.data);
      } else {
        setDeptTableData([]);
      }
    });
  }

  // ✅ Delete
  function handleDelete(deptId) {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        let url = config.url.FAC_URL + "deleteDept?deptId=" + deptId;

        CommonAxiosPost(url)
          .then((response) => {
            if (response?.data?.status === true) {
              successAlert2(response?.data?.message || "Deleted successfully");
              GetServiceTableDetails();
            } else {
              failureAlert(response?.data?.message || "Delete failed");
            }
          })
          .catch((error) => {
            console.error("Delete API Error:", error);
            failureAlert("An error occurred while deleting");
          });
      }
    });
  }

  // ✅ Edit
  const handleEdit = (rowData) => {
    serviceFormik.setValues({
      deptName: rowData.dept_name,
    });

    setServiceId(rowData.dept_id); // Store ID for update

    setTimeout(() => {
      document
        .getElementById("service-form")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  useEffect(() => {
    GetServiceTableDetails();
  }, []);

  const deptTableColumns = [
    serialNumberColumn,
    commonColumn("Department Name", "dept_name", false, "left"),
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="d-flex gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => handleEdit(rowData)}
            >
              <FaEdit size={14} />
            </button>

            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => handleDelete(rowData?.dept_id)}
            >
              <BiTrash size={14} />
            </button>
          </div>
        );
      },
    },
  ];

  return (

    <>
      {/* <div className="overal-stathead">
        <span>Add Department</span>
      </div> */}

      <div className='fac-topbar'>

        <div className='fac-detnew'>
          <h5 className='mb-0'>Add Department</h5>
        </div>

      </div>
      <bie.Container fluid className="px-1">
        <bie.Container className="px-3 mw-100 pb-5">
          <FormikProvider value={serviceFormik}>
            <Form id="service-form" className="newed-from">
              <bie.Row className="g-3">
                <bie.Col lg={4}>
                  <label className="form-label"> Enter Department Name</label>
                  <Field name="deptName" type="text" className="form-control" />
                  <ErrorMessage
                    name="deptName"
                    component="div"
                    className="text-danger"
                  />
                </bie.Col>

                <bie.Col lg={4}>
                  <button
                    type="submit"
                    className="btn btn-success btn-sm"
                    style={{ marginTop: "34px" }}
                  >
                    {serviceId ? "Update" : "Submit"}
                  </button>
                </bie.Col>
              </bie.Row>
              <br />

              {deptTableData?.length > 0 ? (
                <>
                  <div className="table-responsive">
                    <CommonReactTable
                      data={deptTableData}
                      columns={deptTableColumns}
                      filename="Department Report"
                      headerName="Department Report"
                      showFooter={false}
                      showPagination={false}
                      showExcel={true}
                      showPrint={true}
                      excelFileName="Department Details Report"


                    />
                  </div>
                </>
              ) : (<center className="text-danger h5">**** No Data Found ****</center>)}
            </Form>
          </FormikProvider>
        </bie.Container>
      </bie.Container>

    </>
  );
}

export default AddDepartment;
